import { ToastContainer } from 'react-toastify';
import './App.css';
import './scanner.css';

import store, { persistor } from "./redux/store";
import 'react-toastify/dist/ReactToastify.css';
import { AppRoutes } from './routes';
import { BrowserRouter } from 'react-router-dom';
import { GroupChatProvider } from './context/groupchatContext';
import PusherProvider from './context/pusherContext';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Foxit from './components/Foxit';

function App() {

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        bodyClassName="toastify-text-left"
      />
      <Provider store={store}>
        {/* <PersistGate persistor={persistor}> */}
          <BrowserRouter>
            <GroupChatProvider>
              <PusherProvider>
                <AppRoutes />
              </PusherProvider>
            </GroupChatProvider>
          </BrowserRouter>
        {/* </PersistGate> */}
      </Provider>
    </div>
  );
}

export default App;
